<template>
	<div class="wrap">
		<div style="width: 24%;display: inline-block;margin: 0 0.5%;" v-if="data.length>20">
			<img v-if="version=='zh'" src="../assets/img/jxhw.png" style="width: 100%;height: 94%;border-radius: 0;" />
			<img v-if="version=='en'" src="../assets/img/jxhwEn.png" style="width: 100%;height: 94%;border-radius: 0;" />
		</div>
		<div class="box" v-for="(item, index) in data" :key="index" @click="onClick(item)">
			<img :src = "item.coverImg" alt = "">
			<div class="title" >{{item.title}}</div>
			<div class="footer">
			
				<div v-if="userId" class="price">{{isVip?item.memberPrice:item.price}}{{item.units}}</div>
				<div v-else class="price">{{item.price}}{{item.units}}</div>
				<div v-if="title != $t('commodity.groupBuying')" class="num">{{$t('commodity.monthlySales')}}: {{item.sales}}</div>
				<div v-if="title == $t('commodity.groupBuying')" class="num">{{$t('commodity.AlreadyAssembled')}}: {{item.number}}</div>
			</div>
		</div>
  	</div>
</template>

<script>
export default {
	name: "order_item",
	props: {
		data: [],
		isVip: false,
		title: ''
	},
	data() {
		return {
			userId: this.$cookie.get('userId'),
			imgs:'',
			version:'zh',
		}
	},
	mounted() {
		var version = this.version
		setInterval(() => {
			if(this.$cookie.get('language')){
				version = this.$cookie.get('language')
			}
			if(version!=this.version){
				this.version = version
				
				console.log(version,'5----tihs.version：',this.version)
				if(this.version=='en'){
					
				}else{
					
					
				}
			}
		}, 1000)
	},
	methods:{
	  onClick(e){
		  if(this.title == '拼团购') {
			  this.$router.push({
				  path: '/pintuangouDet?id='+e.id+'&title=拼团购'
			  })
		  } else {
			  this.$router.push({
				  path: '/goodsDet?id='+e.id
			  })
		  }
	  }

	}

}
</script>

<style scoped>
	.wrap {
		display: flex;
		flex-wrap: wrap;
		width: 1200px;
	}
	.box {
		width: 24%;
		/* height: 320px; */
		padding: 14px;
		background: #fff;
		border: 1px solid #F6F5F7;
		box-sizing: border-box;
		/* margin-bottom: 20px; */
		    margin: 0 .5% 20px;
	}
	img {
		width: 100%;
		    height: 250px;
		    border-radius: 10px;
	}
	.title {
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		    height: 45px;
	}
	.footer {
		display: flex;
		justify-content: space-between;
		margin-top: 8px;
	}
	.price {
		font-weight: 700;
		color: #ff2d55;
		font-size: 20px;
	}
	.num {
		font-size: 12px;
		color: #666666;
		font-weight: 400;
		line-height: 29px;
	}
</style>



// WEBPACK FOOTER //
// src/components/goods-item.vue